import React from "react";
import styles from "./CompetitorDetails.module.css";
import { linkTarget, toProductHref } from "../../utils/url";

interface Pricing {
    listPrice: number;
    salePrice: number;
}

interface Availability {
    allowPurchases: boolean;
    stock_status: string;
}

interface CompetitorDetailsProps {
    details: {
        id: string;
        competitor_id: string | null;
        content: string;
        competitor_title: string;
        pricing: Pricing;
        availability: Availability;
        sourcepage: string;
        updatetime: string;
        lastchange: string;
        competitor_store: string;
    } | null; // Allow null as a valid type for details
}

const formatDate = (dateString: string | null) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZoneName: "short"
    };
    return date.toLocaleDateString(undefined, options);
};

const CompetitorDetails: React.FC<CompetitorDetailsProps> = ({ details }) => {
    if (!details) return <p>No details available.</p>;

    // Truncate the sourcepage URL by removing "__" and everything after
    const truncatedSourcePage = details.sourcepage.split("__")[0];

    return (
        <div className={styles.competitorDetails}>
            <h1>
                <a href={truncatedSourcePage} target="_blank" rel="noopener noreferrer">
                    {details.competitor_title}
                </a>
            </h1>
            <h2>Κατάστημα: {details.competitor_store}</h2>

            <h3>
                {details.pricing.listPrice > details.pricing.salePrice ? (
                    <>
                        Αρχική: <span style={{ textDecoration: "line-through" }}>{details.pricing.listPrice.toFixed(2)}€</span> - Τελική:{" "}
                        {details.pricing.salePrice.toFixed(2)}€
                    </>
                ) : (
                    <>Τιμή: {details.pricing.listPrice.toFixed(2)}€</>
                )}
            </h3>
            <a href={truncatedSourcePage} target="_blank" rel="noopener noreferrer">
                Περισσότερες πληροφορίες
            </a>

            <div>
                <table>
                    <tbody>
                        <tr>
                            <th>Public</th>
                            <td>
                                {(() => {
                                    const publicUrl = `https://www.public.gr/product/${details.id}`;
                                    const href = toProductHref(publicUrl, details.id) ?? publicUrl;
                                    const target = linkTarget();
                                    const rel = target === "_blank" ? "noopener noreferrer" : undefined;
                                    return (
                                        <a href={href} target={target} rel={rel}>
                                            {details.content} ({details.id})
                                        </a>
                                    );
                                })()}
                            </td>
                        </tr>
                        <tr>
                            <th>{details.competitor_store}</th>
                            <td>
                                <a href={truncatedSourcePage} target="_blank" rel="noopener noreferrer">
                                    {details.competitor_title} ({details.competitor_id})
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <th>Τελευταία ενημέρωση</th>
                            <td>{formatDate(details.updatetime)}</td>
                        </tr>
                        <tr>
                            <th>Τελευταία αλλαγή</th>
                            <td>{formatDate(details.lastchange)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CompetitorDetails;
